import { publicAssetUrl } from '@chegg-wt/core/utils/url'
import { BannerLazyImage } from '../styled'
import { BannerImageProps } from './types'

const BannerImage = ({ urlString, altText }: BannerImageProps): JSX.Element => {
  return <BannerLazyImage src={publicAssetUrl(`${urlString}.webp`)} alt={altText} />
}

export default BannerImage
